
import {defineComponent,ref} from 'vue'
import {message} from 'ant-design-vue'
import store from '@/store'
import {clientSkinColors,ClientSkinId,resolveClientSkin,selectClientSkin} from '@/utils/clientSkin'
const names={classic:'经典蓝',warm:'暖砂原色',mono:'极简黑白',sage:'鼠尾草绿',wine:'勃艮第红',navy:'午夜藏蓝',petrol:'深海青',taupe:'烟灰摩卡',plum:'雾紫灰'}
export default defineComponent({
  props:{iconOnly:{type:Boolean,default:true}},
  setup(){
    const visible=ref(false),selected=ref('classic')
    const skins=Object.keys(clientSkinColors).map(id=>({id:id as ClientSkinId,name:names[id] || id,color:clientSkinColors[id][0]}))
    const openPicker=()=>{selected.value=resolveClientSkin(Number(store.getters.orgId),store.getters.orgInfo,true).id;visible.value=true}
    const choose=(id:ClientSkinId|null)=>{
      if(!selectClientSkin(Number(store.getters.orgId),store.getters.orgInfo,id)){message.warning('暂时无法保存皮肤选择，请稍后重试。');return}
      selected.value=resolveClientSkin(Number(store.getters.orgId),store.getters.orgInfo,true).id
    }
    return{visible,selected,skins,openPicker,choose}
  }
})
